import { useQuery } from "@tanstack/react-query";

import { getFieldSimulations } from "services";

import { GET_FIELD_SIMULATIONS } from "consts";

import { FieldSimulation } from "models";

export const useGetFieldSimulations = ({ fieldId }: { fieldId?: string }) =>
  useQuery<FieldSimulation[]>({
    queryKey: [GET_FIELD_SIMULATIONS, fieldId],
    queryFn: ({ signal }) => (!fieldId ? [] : getFieldSimulations({ fieldId, signal })),
    refetchOnMount: false,
    enabled: !!fieldId,
  });
